import API  from '../index'

const ChangePassword = async(req: {
    current_password: string,
    new_password: string,
    confirm_password: string
}) => {
    return await API.put(`/api/v2/users/my-profile/change-password`, req).then((rep) => {
      return rep.data
    })
}

const ResetPassword = async(profile_id: string) => {
    console.log('profile_id',profile_id)
    return await API.put(`/api/v2/users/${profile_id}/reset-password`).then((rep) => {
      return rep.data
    })
}

const AuthService = {
    ChangePassword,
    ResetPassword
}

export default AuthService